import tmhRequest from '@/config/tmhRequest'

export default {
    searchBusinessReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/businessreport/searchbusinessreportcount',
            method: 'post',
            data: data,
        })
    },
    searchBusinessReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/businessreport/searchbusinessreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportBusinessReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/businessreport/exportbusinessreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/businessreport.js